import { lazy } from "react";

export const NewSectionPage = lazy(() => import("./newSectionPage"));
